import React from 'react';
import {ObjectPropertyDetails} from "../../../types/Object";
import LangStringPropertyView from "./LiteralPropertyView";
import ObjectPropertyView from "./ObjectPropertyView";
import ResourcePropertyView from "./ResourcePropertyView";
import ScalarPropertyView from "./ScalarPropertyView";

const IGNORED_RESOURCE_PROPS = ["id", "type"];

export function resolvePropertyVisualization(property: ObjectPropertyDetails) {
  if (property.value === undefined || property.value === null || property.value.length < 1) {
    return null;
  }

  if (ObjectPropertyView.canHandle(property)) {
    return <ObjectPropertyView property={property}/>;
  }

  // Avoid id and type as external resources
  if (ResourcePropertyView.canHandle(property) && IGNORED_RESOURCE_PROPS.indexOf(property.name) < 0) {
    return <ResourcePropertyView property={property}/>;
  }

  if (LangStringPropertyView.canHandle(property)) {
    return <LangStringPropertyView property={property} defaultLang="en"/>;
  }

  if (ScalarPropertyView.canHandle(property)) {
    return <ScalarPropertyView property={property}/>;
  }

  console.error(`Cannot resolve visualization for property ${property.name}`);
  return <ScalarPropertyView property={property}/>;
}
